import { createContext, useContext, type ReactNode } from 'react';

/// O ícone de ajuda de cada página leva a Ajuda direto ao fluxo daquela página (ADR 0047). A casca
/// da empresa sabe onde a pessoa está e entrega o ícone pronto; a página só reserva o lugar dele, no
/// topo à direita, do outro lado do título. Fora da casca (testes de um módulo, console da
/// plataforma) não há ícone, e o cabeçalho fica como era.
export const PageHelpContext = createContext<ReactNode>(null);

/// O ícone pronto, ou nada fora da casca. Quem o desenha é o cabeçalho da página (`PageHeader`).
export function usePageHelp() {
  return useContext(PageHelpContext);
}
